<template>
    <div class="deteil">
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/AccountManage' }">账号管理</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="15">
                        <el-col :span="1.2"
                            ><div class="grid-content bg-purple">
                                <span>账号名称:</span>
                            </div></el-col
                        >
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInput" placeholder="请输入账号名称" clearable></el-input></div
                        ></el-col>
                        <el-col :span="15">
                            <el-button type="primary" icon="el-icon-search" @click="Search()">查询</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="addModal()">新增</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="50">
                            <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column :resizable="false" prop="name" label="账号名称" align="center"></el-table-column>
                        <el-table-column :resizable="false" prop="loginName" label="登录名" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.row.loginName !== 'admin'"
                                    @click="delectModal(scope.row.id)"
                                    type="text"
                                    size="small"
                                    >删除</el-button
                                >
                                <el-button type="text" size="small" @click="reset(scope.row.id)">重置密码</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页区域 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <!-- 新增账号弹框 -->
        <el-dialog title="新增账号" :visible.sync="dialogVisible" width="30%" :before-close="handleToClose" :close-on-click-modal="false">
            <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
                <el-form-item label="登录名" prop="loginName">
                    <el-input v-model="addForm.loginName"></el-input>
                </el-form-item>
                <el-form-item label="账号名称" prop="name">
                    <el-input v-model="addForm.name"></el-input>
                </el-form-item>
                <el-form-item label="账号密码" prop="password">
                    <el-input :type="pwdType1" v-model="addForm.password">
                        <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd1 }" @click="handleToPwd1"></i>
                    </el-input>
                </el-form-item>
                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取消</el-button>
                    <el-button type="primary" @click="handleToSave">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        var checkLoginName = (rule, value, callback) => {
            let data = {};
            data.loginName = this.addForm.loginName;
            data.id = '';
            this.$axios.post('sys/user/checkLoginName', data).then(res => {
                if (res.data.code != 0) {
                    callback(new Error(res.data.data));
                    this.addForm.loginName = '';
                } else {
                    callback();
                }
            });
        };
        var validatePass = (rule, value, callback) => {
            console.log(value);
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value.length < 5 || value.length > 16) {
                callback(new Error('密码长度为6-16位'));
            } else {
                var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                if (!reg.test(value)) {
                    callback(new Error('密码仅支持字母、数字的组合'));
                } else {
                    callback();
                }
            }
        };
        return {
            searchInput: '',
            dialogVisible: false,
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                loginName: '', //商家名称
                name: ''
            },
            // 日期
            date: null,
            // 数据列表
            tableData: [],
            // 数据总数
            total: 0,
            pwdType1: 'password',
            isPwd1: false,
            // 下拉框的数据列表
            addForm: {
                loginName: '',
                password: '',
                name: ''
            },
            rules: {
                loginName: [
                    { required: true, message: '请输入登录名', trigger: 'blur' },
                    { validator: checkLoginName, message: '登录名重复', trigger: 'blur' }
                ],
                name: [{ required: true, message: '请输入账号名称', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入账号密码', trigger: 'blur' },
                    {
                        validator: validatePass,
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    created() {
        // 获取数据列表
        //this.getSysInfoList();
    },
    methods: {
        async Search() {
            console.log(this.searchInput);
            const res = await this.$axios.post('sys/user/list', { loginName: this.searchInput, pageNum: 1, pageSize: 10 });
            console.log(res);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        async getSysInfoList() {
            const res = await this.$axios.post('sys/user/list', this.searchInfo);
            console.log(res);

            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            } else {
                this.$message.error(`${res.data.data}`);
            }
            // console.log(res);
        },
        //查看
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getSysInfoList();
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getSysInfoList();
        },
        //重置密码
        reset(id) {
            this.$confirm('此操作将重置该用户密码, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await this.$axios.post('sys/user/resetPwd', {
                        id: id,
                        password: ''
                    });
                    if (res.data.code == 0) {
                        this.$message.success(`${res.data.data},新密码为: 123456`);
                    } else {
                        this.$message.error(`${res.data.data}`);
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消重置'
                    });
                });
        },
        delectModal(id) {
            this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await this.$axios.post('sys/user/batch/delete', {
                        id
                    });
                    console.log(res);
                    if (res.data.code == 0) {
                        this.$message.success('删除成功');
                        this.getSysInfoList();
                        // this.getTreeData();
                    } else {
                        this.$message.error(`${res.msg}`);
                    }
                })
                .catch(() => {
                    this.$message.info('已取消删除');
                });
        },
        async handleToSave() {
            this.$refs.addForm.validate(async valid => {
                if (valid) {
                    // 角色数组转为,分割的字符串
                    const res = await this.$axios.post('sys/user/save', this.addForm);
                    console.log(res);
                    if (res.data.code == 0) {
                        this.dialogVisible = false;
                        this.$refs.addForm.resetFields();
                        this.$message.success('新增成功');
                        this.isPwd1 = false;
                        this.pwdType1 = 'password';
                        this.getSysInfoList();
                    } else {
                        this.$message.error(`${res.data.data}`);
                        this.handleToClose();
                    }
                    console.log(this.addForm);
                } else {
                    return false;
                }
            });
        },
        addModal() {
            this.dialogVisible = true;
        },
        handleToClose(formName) {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.dialogVisible = false;
                    this.isPwd1 = false;
                    this.pwdType1 = 'password';
                    // 重置表单
                    this.$refs.addForm.resetFields();
                })
                .catch(() => {});
        },
        // 显示隐藏密码
        handleToPwd1() {
            this.isPwd1 = !this.isPwd1;
            if (this.isPwd1) {
                this.pwdType1 = 'text';
            } else {
                this.pwdType1 = 'password';
            }
        }
        // dialog关闭事件
    }
};
</script>
<style lang="less" scoped>
.el-table {
    margin-top: 20px;
}
.el-pagination {
    margin-top: 20px;
    text-align: center;
}
.dialog-footer {
    text-align: center;
}
.pwd {
    color: #409eff;
}
</style>
